<form [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">

  <div class="logo-container">
    <div class="logo"></div>
  </div>

  <span class="new-password-title">
        <h3>{{i18nService.getMessage('reset.change.password.title')}}</h3>
    </span>

  <span *ngIf="success">{{i18nService.getMessage('changepassword.new.password.stored.successfully')}}</span>

  <span class="text-danger" *ngIf="!isTokenValid">{{i18nService.getMessage('reset.change.password.invalid')}}</span>

  <div *ngIf="isTokenValid && !success">
        <span class="new-password-intro">
            {{i18nService.getMessage('reset.change.password.info')}} {{i18nService.getMessage('reset.change.password.requirements')}}
        </span>

    <div class="form-new-password-container">
      <!-- New Password Field -->
      <div class="mb-3">
        <label class="form-label" for="password_new">{{i18nService.getMessage('reset.change.password.new')}}</label>
        <div class="input-group has-validation">
          <input id="new:password_new" [type]="passwordNewVisible ? 'text' : 'password'" formControlName="passwordNew" class="form-control" [ngClass]="{ 'is-invalid': submitted && form.passwordNew.errors }"/>
          <button id="show-password-new-button" type="button" class="input-group-text"
                  [attr.aria-label]="i18nService.getMessage(passwordNewVisible ? 'login.input.password.hide' : 'login.input.password.show')"
                  (mousedown)="$event.preventDefault()"
                  (click)="passwordNewVisible = !passwordNewVisible">
            <img [src]="passwordNewVisible ? 'assets/font-awesome/light/eye-slash.svg' : 'assets/font-awesome/light/eye.svg'"
                 alt="" class="show-password-icon"/>
          </button>
          <div class="invalid-feedback">
            <div *ngIf="form.passwordNew.errors?.required">{{i18nService.getMessage('reset.change.password.new.required')}}</div>
          </div>
        </div>
      </div>

      <!-- Repeat New Password Field -->
      <div class="mb-3">
        <label class="form-label" for="password_new_repeat">{{i18nService.getMessage('reset.change.password.repeat')}}</label>
        <div class="input-group has-validation">
          <input id="new:password_new_repeat" [type]="passwordNewRepeatVisible ? 'text' : 'password'" formControlName="passwordNewRepeat" class="form-control" [ngClass]="{ 'is-invalid': submitted && form.passwordNewRepeat.errors }"/>
          <button id="show-password-new-repeat-button" type="button" class="input-group-text"
                  [attr.aria-label]="i18nService.getMessage(passwordNewRepeatVisible ? 'login.input.password.hide' : 'login.input.password.show')"
                  (mousedown)="$event.preventDefault()"
                  (click)="passwordNewRepeatVisible = !passwordNewRepeatVisible">
            <img [src]="passwordNewRepeatVisible ? 'assets/font-awesome/light/eye-slash.svg' : 'assets/font-awesome/light/eye.svg'"
                 alt="" class="show-password-icon"/>
          </button>
          <div class="invalid-feedback">
            <div *ngIf="form.passwordNewRepeat.errors?.required">{{i18nService.getMessage('reset.change.password.repeat.required')}}</div>
          </div>
        </div>
      </div>

      <!-- Errors Display -->
      <div class="mb-3 text-danger" *ngIf="!processing">
        <div *ngFor="let error of errors">{{i18nService.getMessage(error.messageCode)}}</div>
      </div>

      <!-- Submit Button -->
      <div class="mb-3">
        <button id="login-button" [disabled]="processing || initialLoading" class="btn btn-primary">
          <span *ngIf="processing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="!processing">{{i18nService.getMessage('reset.change.password.button.reset')}}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Back to Login Link -->
  <div class="mb-3">
    <a *ngIf="!isTokenValid || success" [routerLink]="backToLoginLink">
      {{i18nService.getMessage('login.action.back_to_login')}}
    </a>
  </div>

</form>

